var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notifications fixed" },
    [
      _c(
        "transition-group",
        { attrs: { name: "fade-in-down" } },
        _vm._l(_vm.notifications, function(notification, index) {
          return _c(
            "div",
            {
              key: notification.type + "_" + index,
              staticClass: "notification mt30 border-box cl-white",
              class: notification.type
            },
            [
              _c(
                "div",
                {
                  staticClass: "message p20",
                  attrs: { "data-testid": "notificationMessage" },
                  on: {
                    click: function($event) {
                      return _vm.execAction(notification.action1, index)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(notification.message) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "py10 px20 pointer weight-400 action-border notification-action uppercase",
                    class: "border-" + notification.type,
                    attrs: {
                      id: "notificationAction1",
                      "data-testid": "notificationAction1"
                    },
                    on: {
                      click: function($event) {
                        return _vm.execAction(notification.action1, index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(notification.action1.label) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                notification.action2
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "py10 px20 pointer weight-400 notification-action uppercase",
                        attrs: {
                          id: "notificationAction2",
                          "data-testid": "notificationAction2"
                        },
                        on: {
                          click: function($event) {
                            return _vm.execAction(notification.action2, index)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(notification.action2.label) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }